import { Link } from "react-router-dom";
import "./css/GuideCard.css";

export default function GuideCard({ guide }) {
    const slug = guide.slug || guide.id;

    // Smart cover fallback
    const cover =
        guide.heroImage ||
        guide.cover ||
        (guide.gallery && guide.gallery[0]) ||
        "/guide-placeholder.jpg";

    return (
        <Link
            to={`/${slug}`}
            className="guide-card"
            aria-label={`Open guide ${guide.title}`}
        >
            <div
                className="guide-card-media"
                style={{ backgroundImage: `url(${cover})` }}
            >
                <div className="guide-card-gradient" />

                <div className="guide-card-header">
                    <span className="guide-badge">Guide</span>
                </div>

                <div className="guide-card-title">
                    <h3>{guide.title}</h3>
                    {guide.subtitle && <p>{guide.subtitle}</p>}
                </div>
            </div>
        </Link>
    );
}
